export const profileDropDown = (type) => ({
  type,
});
